import React, { FC, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface RoundTagProps {
  children?: ReactNode;
  className?: string;
}

export const RoundTag: FC<RoundTagProps> = ({
  children,
  className,
}: RoundTagProps) => {
  return (
    <div
      className={cn(
        "px-2 py-1.5 rounded-2xl outline-1 outline-offset-[-1px] outline-neutral-200 text-center text-zinc-900 text-xs font-normal leading-[9px] tracking-tight bg-white",
        className,
      )}
    >
      {children}
    </div>
  );
};
